import React from "react";

const Facilities = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>
          The Particulars of facilities available to citizens for obtaining
          information
        </h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <ol>
          <li>Right To Information</li>
          <li>By Visiting Website</li>
          <li>By Visiting Office Manually Or Through Phone Call</li>
        </ol>
      </div>
    </div>
  );
};

export default Facilities;
